import React from "react";
import { useAuth } from "@/context/AuthContext";
import { fmtMoney } from "@/lib/format";
import { Coins } from "lucide-react";

const Wallet = () => {
  const { wallet } = useAuth();

  return (
    <div className="max-w-2xl space-y-6" data-testid="wallet-page">
      <div>
        <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground font-semibold">Earnings</div>
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight mt-1">Your earnings</h1>
        <p className="mt-2 text-sm text-muted-foreground">Paid on-chain straight to your connected wallet. PAYD never holds your money.</p>
      </div>

      <div className="bg-primary text-primary-foreground rounded-2xl p-8">
        <div className="flex items-center justify-between">
          <div className="text-xs uppercase tracking-[0.2em] opacity-80 font-semibold">Total received</div>
          <Coins className="w-5 h-5 opacity-80" />
        </div>
        <div className="mt-4 font-display font-bold text-4xl sm:text-5xl tracking-tight break-words" data-testid="wallet-balance-amount">{fmtMoney(wallet.balance, wallet.currency)}</div>
        <div className="mt-2 text-sm opacity-80">Released to your wallet from milestones and claimed invoices.</div>
      </div>
    </div>
  );
};

export default Wallet;
